import { render, staticRenderFns } from "./form-paragraph-preview.vue?vue&type=template&id=54716312&scoped=true&"
import script from "./form-paragraph-preview.vue?vue&type=script&lang=js&"
export * from "./form-paragraph-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-paragraph-preview.vue?vue&type=style&index=0&id=54716312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54716312",
  null
  
)

component.options.__file = "form-paragraph-preview.vue"
export default component.exports